import { render, staticRenderFns } from "./BannersManager.vue?vue&type=template&id=2fed05b6&scoped=true"
import script from "./BannersManager.vue?vue&type=script&lang=js"
export * from "./BannersManager.vue?vue&type=script&lang=js"
import style0 from "./BannersManager.vue?vue&type=style&index=0&id=2fed05b6&prod&lang=scss"
import style1 from "./BannersManager.vue?vue&type=style&index=1&id=2fed05b6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fed05b6",
  null
  
)

export default component.exports